const {
	default: { breakXtraSmall },
} = require('../../../../js/sass-variables');
const { mediaQueryMin, trackGtm, trackGtm4 } = require('util/functions');
const MiniSwipe = require('../../../../js/miniSwipe');

module.exports = {
	init() {
		const smallImageAboveTitleList = this.root.querySelectorAll(
			'.small-image-above-title a',
		);
		const widgetName = this.root.getAttribute('data-parent');
		const widetTitle = this.root.getAttribute('data-title');

		Object.assign(this, MiniSwipe);

		this.initialize({
			swipedList: this.root.querySelectorAll('.small-image-above-title'),
			touchZone: this.root,
			swipeContainer: this.root,
			hasSwipe: false,
		});

		smallImageAboveTitleList.forEach(element => {
			element.addEventListener('click', () => {
				const readingTime = element
					.closest('.small-image-above-title')
					?.querySelector('.small-image-above-title--reading-time');
				const categoryName = element
					.closest('.small-image-above-title')
					?.querySelector('.category-title');
				const linkText = element.querySelector('img')
					? element.querySelector('img')?.getAttribute('alt')
						? `Alt text: ${element.querySelector('img')?.getAttribute('alt')}`
						: 'Alt text: not set'
					: element.innerText;
				trackGtm({
					eventCategory: 'articles',
					eventAction: 'Related Articles',
					eventLabel: element.href,
				});
				trackGtm4({
					event: 'GA4_event_c_related_article',
					widget_name: widgetName,
					widget_title: widetTitle ? widetTitle : 'Title not set',
					category_name: categoryName
						? categoryName.innerText
						: 'Category not set',
					link_text: linkText,
					link_url: element.href,
					reading_time: readingTime ? readingTime.innerText : 'No reading time',
				});
			});
		});
	},
	onResize() {
		if (mediaQueryMin(breakXtraSmall)) {
			// desktop
			this.deactivate();
		} else {
			// mobile
			this.activate();
		}
	},
};
